import React from 'react';
import { clsx } from 'clsx';

import { InputContainer, Props as BaseProps } from '../input-container';

type HtmlInputProps = Omit<JSX.IntrinsicElements['input'], 'ref'>;
type Props = HtmlInputProps &
  BaseProps & {
    register: (any: any) => any;
  };

const DateInput: React.FC<Props> = ({ id, label, value, onChange, error, register, ...props }) => (
  <InputContainer id={id} label={label} error={error}>
    <div className="relative flex-grow focus-within:z-10">
      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
        <svg
          className="h-5 w-5 text-gray-400"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
      </div>

      <input
        {...props}
        id={id}
        name={props.name || id}
        type="date"
        className={clsx(
          'form-input block w-full rounded-md pl-10 transition ease-in-out duration-150 sm:text-sm sm:leading-5',
          {
            'border-red-300 text-red-900 placeholder-red-300 focus:border-red-300 focus:ring-red': error,
          }
        )}
        onChange={onChange}
        ref={register({ required: props.required, min: props.min, max: props.max })}
        aria-required={props.required}
      />
    </div>
  </InputContainer>
);

export default DateInput;
